import PropTypes from "prop-types"
import { formatNumber, compactInteger } from "humanize-plus"
import classname from "classnames"
import Tooltip from "./tooltip"
import ArrowIcon from "images/partners/premium_insights/arrow-down.svg"

import "./insights.scss"

const StatCard = ({
  statText,
  stat,
  statUnitText,
  compactThreshold,
  compactStat,
  changeRate,
  timePeriodInDays,
  className,
  subText,
  precision,
  tooltipText,
  lowThreshold,
  lowValue,
  isPercentage,
  lowerIsBetter,
}) => (
  <div styleName="stat-card" className={`stat-card ${className}`}>
    <div>
      <h4>
        {statText}
        {tooltipText && (
          <div className="tooltip-icon">
            <Tooltip content={tooltipText} />
          </div>
        )}
      </h4>
      <div styleName="stat-details">
        <div className="stats" styleName="stats">
          <h2>
            {lowThreshold && stat < lowThreshold
              ? lowValue
              : statPrecision(
                  stat,
                  precision,
                  compactThreshold,
                  compactStat,
                  isPercentage
                )}
          </h2>
          <div className="change-container" styleName="change-container">
            {changeRate || changeRate === 0 ? (
              <ChangeRateText
                changeRate={changeRate}
                timePeriodInDays={timePeriodInDays}
                lowerIsBetter={lowerIsBetter}
              />
            ) : (
              statUnitText && <span styleName="times">{statUnitText}</span>
            )}
          </div>
        </div>
        {subText && <span styleName="sub-text">{subText}</span>}
      </div>
    </div>
  </div>
)

const ChangeRateText = ({ changeRate, timePeriodInDays, lowerIsBetter }) => {
  if (!isFinite(changeRate)) {
    return null
  }
  return (
    <>
      <span
        styleName={classname("change-indicator", {
          "negative-change": changeRate < 0,
          "positive-change": changeRate >= 0,
          "lower-is-better": lowerIsBetter,
        })}
      >
        <span
          styleName="icon"
          dangerouslySetInnerHTML={{ __html: ArrowIcon }}
        />
        <span styleName="change">
          {`${Math.abs(changeRate * 100).toFixed(
            Math.abs(changeRate * 100) > 1 ? 0 : 1
          )}%`}
        </span>
      </span>
      <span className="time-period">from last {timePeriodInDays} days</span>
    </>
  )
}

const statPrecision = (
  stat,
  precision,
  compactThreshold,
  compactStat,
  isPercentage
) => {
  if (stat > compactThreshold && compactStat) {
    return compactInteger(stat, stat > 999999 ? 1 : 0)
  } else if (isPercentage) {
    return `${stat.toFixed(precision)}%`
  } else {
    return formatNumber(stat, precision)
  }
}

StatCard.propTypes = {
  stat: PropTypes.number,
  statUnitText: PropTypes.string,
  compactThreshold: PropTypes.number,
  compactStat: PropTypes.bool,
  changeRate: PropTypes.number,
  timePeriodInDays: PropTypes.number,
  statText: PropTypes.string,
  subText: PropTypes.string,
  className: PropTypes.string,
  precision: PropTypes.number,
  tooltipText: PropTypes.string,
  lowThreshold: PropTypes.number,
  lowValue: PropTypes.string,
  isPercentage: PropTypes.bool,
  lowerIsBetter: PropTypes.bool,
}

StatCard.defaultProps = {
  compactThreshold: 999999,
  compactStat: true,
  precision: 0,
}

export default StatCard
